import { type FormEvent, useState } from 'react';
import css from './Login.module.css';

export function Login({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    setError(null);
    try {
      const r = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (r.ok) {
        onSuccess();
      } else {
        setError('wrong password');
      }
    } catch {
      setError('network error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={css.wrap}>
      <form className={css.form} onSubmit={submit}>
        <h1 className={css.title}>gymdash</h1>
        <input
          className={css.input}
          type="password"
          placeholder="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
        />
        <button className={css.button} type="submit" disabled={loading || !password}>
          {loading ? '…' : 'sign in'}
        </button>
        {error && <p className={css.error}>{error}</p>}
      </form>
    </div>
  );
}
